import * as changeCase from 'change-case'

export const toDotSnakeCase = (str: string) =>
  str
    .split('.')
    .map((col) => changeCase.snakeCase(col))
    .join('.')
